import { Link } from 'react-router-dom';

import productImg from '../../assets/img/product/product-3.jpg';

const SingleProduct = (props) => {
  const { itemClass, Image, Title, Price, Categories, btnText, url } = props;
  const titleText = Title ? Title : 'Ooru Mitra App';
  const titleLink = url ? (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {titleText}
    </a>
  ) : (
    <Link to="">
      {titleText}
    </Link>
  );

  return (
    <div className={itemClass ? itemClass : 'product__item text-center'}>
      <div className="product__img">
        <img src={Image ? Image : productImg} alt="" />
      
        {/* <div className="product__icon">
          <Link to="">
            <i className="fal fa-shopping-basket"></i>
          </Link>
          <Link to="">
            <i className="fal fa-heart"></i>
          </Link>
        </div> */}
      </div>
      <div className="product__content">
        <div className="product__content-text">
          <h4>{titleLink}</h4>
                    <span>{Categories ? Categories : 'Rural Marketplace'}</span>

          {/* <span>{Price ? Price : '$555'}</span> */}
        </div>
        {/* <div className="product__button">
          <a className="yellow-btn-sm" href="#">
            {btnText ? btnText : 'Add To Card'}
          </a>
        </div> */}
      </div>
    </div>
  );
};

export default SingleProduct;
